import { createContext, useContext, type ReactNode } from "react";

import type { StreamClient, StreamStatus } from "../api/stream";
import type { StreamTopic } from "../contract/types";
import { useNetworkId } from "../config/ConfigProvider";
import { useStream } from "./useStream";

interface StreamContextValue {
  stream: StreamClient | null;
  status: StreamStatus;
}

const StreamContext = createContext<StreamContextValue | null>(null);

const COCKPIT_TOPICS: StreamTopic[] = ["journeys", "deviations", "alerts", "sources"];

/** Ouvre un flux temps réel unique pour tout le cockpit et le partage. */
export function StreamProvider({
  children,
  topics = COCKPIT_TOPICS,
}: {
  children: ReactNode;
  topics?: StreamTopic[];
}) {
  const networkId = useNetworkId();
  const { stream, status } = useStream(networkId, topics);
  return <StreamContext.Provider value={{ stream, status }}>{children}</StreamContext.Provider>;
}

export function useStreamContext(): StreamContextValue {
  const value = useContext(StreamContext);
  if (!value) throw new Error("useStreamContext doit être utilisé sous <StreamProvider>");
  return value;
}
